import ApiContext from 'api/ApiContext';
import { useContext } from 'react';
import { useQuery } from 'react-query';
import { getInternalUrl } from 'utils/routing';

const useNavPolls = (pollId: string, parentId: string) => {
  const { language, getPollDays } = useContext(ApiContext);

  const query = useQuery(['polling_days'], getPollDays, {
    refetchInterval: false,
    cacheTime: Infinity,
    staleTime: Infinity,
  });

  const pollsOfDay = query.data?.data?.find(
    (day) => parseInt(day.id, 10) === parseInt(parentId, 10),
  )?.issues;

  const indexOfCurrentPoll = pollsOfDay?.findIndex(
    (issue) => parseInt(issue.id, 10) === parseInt(pollId, 10),
  );
  const numOfPollsOnDay = pollsOfDay?.length;

  if (numOfPollsOnDay === 1)
    return {
      prevPollLink: null,
      nextPollLink: null,
      prevPollTitle: null,
      nextPollTitle: null,
    };

  const prevPoll = pollsOfDay?.[indexOfCurrentPoll - 1];
  const nextPoll = pollsOfDay?.[indexOfCurrentPoll + 1];

  const prevPollLink = prevPoll && getInternalUrl(prevPoll, 'poll');
  const nextPollLink = nextPoll && getInternalUrl(nextPoll, 'poll');

  const prevPollTitle = prevPoll?.short_title?.[language] || prevPoll?.title[language];
  const nextPollTitle = nextPoll?.short_title?.[language] || nextPoll?.title[language];
  return { prevPollLink, nextPollLink, prevPollTitle, nextPollTitle };
};

export default useNavPolls;
